module.exports = __webpack_public_path__ + "img/DE05906.922325e2.png";